<template>
  <div class="calendar-month">
    <div class="calendar-month-header">
      <div
        v-for="h in headers"
        :key="h"
        class="calendar-month-th"
      >{{ h }}</div>
    </div>
    <div
      @dragover="dropover"
      @drop="drop"
    >
      <div class="calendar-month-panel">
        <day-box
          v-for="(day, index) in days"
          :key="index"
          :item="day"
          :curDate="curDate"
        ></day-box>
      </div>
      <div
        v-for="(item, index) in weeks"
        :key="index"
        class="calendar-month-tasks-layer"
        :style="{
          top:`${index * 70 + 55}px`
        }"
      >
        <week-task
          :tasks="taskGroup[index]"
          :isMore="isMore"
          :monday="days[index*7].millisecond"
          :size="97"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DayBox from './dayBox'
import WeekTask from '../tasks/weekTask'
import calendarUtil from '@/utils/calendar'
import mixin from '@/mixins/calendar'
import { mapState } from 'vuex'
export default {
  name: 'CalendarMonthView',
  mixins: [ mixin ],
  components: {
    DayBox,
    WeekTask
  },
  props: {
    curDate: {
      type: String,
      default: moment().format('YYYY-MM')
    }
  },
  data () {
    return {
      headers: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      days: calendarUtil.createMonthCalendar(this.curDate),
      weeks: new Array(6),
      taskGroup: [],
      isMore: false,
      dargFlag: {},
      pageX: -1,
      pageY: -1,
      cacheRestDay: []
    }
  },
  computed: {
    ...mapState({
      tasks: state => state.calendar.tasks
    })
  },
  watch: {
    curDate (newVal) {
      this.days = calendarUtil.createMonthCalendar(newVal)
      this.setParams()
      this.setRestDay()
    },
    '$store.state.calendar.tasks': {
      handler: function (newer, older) {
        this.taskGroup = this.setTaskGroup(newer)
        this.setRestDay()
      },
      deep: true
    },
    pageX (after, before) {
      this._dragTaskTime(after, before)
    },
    pageY (after, before) {
      this._dragTaskTime(after, before, 7)
    }
  },
  created () {
    this.setParams()
    this.setRestDay()
  },
  methods: {
    dropover (event) {
      this.pageX = Math.floor((event.pageX - 20) / 98)
      this.pageY = Math.floor((event.pageY - 140) / 70)
      event.dataTransfer.dropEffect = 'move'
      event.preventDefault()
    },
    drop (event) {
      if (!this.$store.state.calendar.draggingCreateTask) {
        let draggingTask = this.$store.state.calendar.draggingTask
        this.$postMessage.syncProcessDate(draggingTask)
        this._resetTaskTime(draggingTask)
      }

      this.pageX = -1
      this.pageY = -1
    },
    setParams () {
      this.$store.commit('updateCalendarParams', {
        rangeFrom: this.days[0].format,
        rangeTo: this.days[this.days.length - 1].format
      })
    },
    /**
     * 对现有任务按周分组，跨周任务会在所跨组中出现
     */
    setTaskGroup (paramsArr = []) {
      let array = JSON.parse(JSON.stringify(paramsArr))
      this.isMore = array.length > 200
      let results = []
      let weekNumS = 0
      let weekNumE = 0
      const firstDay = this.days[0]
      this._cDays = Object.assign({}, calendarUtil.createMonthCalendar(this.curDate))
      array.map((item) => {
        this.setTaskNumByDay(firstDay, item)
        weekNumS = Math.floor(moment(item.startTime || item.dueTime).diff(moment(firstDay.millisecond).startOf('day'), 'days') / 7)
        weekNumE = Math.floor(moment(item.endTime || item.dueTime).diff(moment(firstDay.millisecond).startOf('day'), 'days') / 7)
        for (let i = weekNumS; i < weekNumE + 1; i++) {
          results[i] = results[i] || []
          results[i].push(item)
        }
      })
      this.days = Object.assign({}, this._cDays)
      return results
    },
    /**
     * 按天统计任务数,并将任务加入到每天
     */
    setTaskNumByDay (firstDay, item) {
      const param = Math.max(moment(item.startTime || item.dueTime).diff(moment(firstDay.millisecond).startOf('day'), 'days'), 0)
      const length = moment(item.endTime || item.dueTime).diff(moment(Math.max(firstDay.millisecond, item.startTime || item.dueTime)).startOf('day'), 'days') + 1
      for (let index = 0; index < length; index++) {
        // 防止越界报错
        if (!this._cDays[param + index]) {
          break
        }
        this._cDays[param + index].tasks = this._cDays[param + index].tasks || []
        this._cDays[param + index].tasks.push(item)
      }
    },
    /**
     * 设置休息日
     */
    async setRestDay () {
      const DAYS_COUNT = 7 * 6
      let startMoment = this.curDate ? moment(this.curDate, 'YYYY-MM') : moment()
      let firstDayOfMonth = startMoment.startOf('month')
      let firstDay = firstDayOfMonth.startOf('week')
      let firstDayUnix = firstDay.valueOf()
      let lastDay = firstDay.add(DAYS_COUNT - 1, 'days')
      let lastDayUnix = lastDay.valueOf()
      let _data = null
      let isSuccess = true
      // 先查一遍缓存，避免频繁请求接口导致workIcon闪烁
      this.cacheRestDay.forEach(item => {
        if (item.firstDayUnix === firstDayUnix && item.lastDayUnix === lastDayUnix) {
          _data = item.data
        }
      })
      if (!_data) {
        let res = await this._getHolidayByTime(firstDayUnix, lastDayUnix)
        _data = res.data
        isSuccess = res.isSuccess
        this.cacheRestDay.push({
          firstDayUnix,
          lastDayUnix,
          data: res.data
        })
      }
      if (isSuccess) {
        let specialTime = _data.rest.concat(_data.work)
        let daysLength = this.days instanceof Array ? this.days.length : Object.keys(this.days).length
        for (let i = 0; i < specialTime.length; i++) {
          const special = specialTime[i]
          for (let j = 0; j < daysLength; j++) {
            let day = this.days[j]
            if (day.millisecond === special.day) {
              this.days[j]['dayType'] = special.dayType
              this.days[j]['restType'] = special.restType
            }
          }
        }
      }
      // }
    }
  }
}
</script>
<style lang="stylus">
.calendar-month
  position relative
  margin-top 5px
  &-header
    margin-right 8px
    display flex
    flex-direction row
    line-height 40px
    justify-content space-between
    align-items flex-start
    flex-wrap nowrap
    color #bfbfbf
    border-bottom 1px solid #f0f0f0
  &-th
    flex 1
    text-align center
    color #000
    font-size 12px
  &-panel
    display flex
    flex-wrap wrap
  &-day
    width 14.2%
    height 70px
    box-shadow inset -1px 0 0 0 #f0f0f0, inset 0 -1px 0 0 #f0f0f0
    &:nth-child(7n)
      box-shadow inset 0 -1px 0 0 #f0f0f0
  &-tasks-layer
    position absolute
    width 100%
</style>
